module.exports = __webpack_public_path__ + "static/media/print-search.b87796ee.svg";